<template>
  <div class="whole">
    <div class="breadcrumbs flex ai">
      <div class="breadcrumbs-txt">主页</div>
    </div>
    <div class="main-content">
      <div class="flex column" style="padding: 0 0.32rem; box-sizing: border-box">
        <img class="banner" src="@/assets/mobile/home/banner.png" alt="" />
        <div class="content-txt">Science That Matters</div>
        <div class="nutrition-box">
          <img @click="enterProduct('专业营养')" class="nutrition" src="@/assets/mobile/home/nutrition1.png" alt="" />
          <img @click="enterProduct('基础营养')" class="nutrition" src="@/assets/mobile/home/nutrition2.png" alt="" />
          <img @click="enterProduct('果味营养')" class="nutrition" src="@/assets/mobile/home/nutrition3.png" alt="" />
        </div>
      </div>
      <MobileFooter />
    </div>
  </div>
</template>

<script setup>
import MobileFooter from "@/components/mobileFooter.vue";
import { useRouter } from "vue-router";
const router = useRouter();
// 进入产品页面
const enterProduct = (type) => {
  router.push({ name: "MobileProduct", query: { type: type } });
};
</script>

<style src="./mobileHome.css" scoped></style>
